import DeleteDriverModal from './DeleteDriverModal';
export default DeleteDriverModal;



// WEBPACK FOOTER //
// ./src/components/App/DriversManagerDashboard/SelectableDrivers/DeleteDriverModal/index.js